import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sceneConstructorBgMenu" }
const _hoisted_2 = {
  key: 0,
  fill: "currentColor",
  viewBox: "0 0 512 512"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "m193 260l-11-11 74-74 75 74-12 11-55-54 0 242-16 0 0-242z m206-76c0-2 1-3 1-4 0-64-53-116-117-116-46 0-86 27-105 66-8-4-17-6-26-6-30 0-55 23-59 52-36 12-61 46-61 86 0 50 40 90 90 90l91 0 0-16-91 0c-40 0-74-33-74-75 0-31 20-61 50-71l9-3 1-9c4-21 22-39 44-39 7 0 14 1 20 5l14 6 6-13c17-35 52-58 91-58 55 0 100 44 100 99 0 14 0 21 0 21l15 0c37 0 66 33 66 70 0 37-30 67-66 67l-101 0 0 16 101 0c45 0 82-37 82-83 0-45-35-85-81-85z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  fill: "currentColor",
  viewBox: "0 0 512 512"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "m502 89c0 0 23-23 0-46l-23-22c-22-23-45 0-45 0l-113 113c0 0-23 23-45 0l-23-23c-45-45-90 0-90 0l-23 23l113 113l23 23l113 113l22-23c0 0 46-45 0-90c-9-10-16-17-22-23c-23-22 0-45 0-45z m-57-34c7-6 17-6 23 0c6 6 6 16 0 22c-6 7-16 7-23 0c-6-6-6-16 0-22z m-294 136l-22-23c-7-6-17-6-23 0l-91 90c-6 7-6 17 0 23l23 23c6 6 16 6 23 0l90-91c6-6 6-16 0-22z m68 67l-23-22c-6-6-16-6-22 0l-91 90c-6 7-6 17 0 23l23 23c6 6 16 6 23 0l90-91c6-6 6-16 0-23z m68 68l-23-22c-6-6-16-6-22 0l-91 90c-6 6-6 17 0 23l23 22c6 7 16 7 22 0l91-90c6-6 6-16 0-23z m45 46c-6-7-16-7-22 0l-91 90c-6 6-6 16 0 23l23 22c6 7 16 7 22 0l91-90c6-6 6-17 0-23z" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneConstructorMenuItemIcon = _resolveComponent("SceneConstructorMenuItemIcon")!
  const _component_SceneConstructorMenuItem = _resolveComponent("SceneConstructorMenuItem")!
  const _component_SceneConstructorMenu = _resolveComponent("SceneConstructorMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SceneConstructorMenu, {
      showBackButton: true,
      onGoBack: _cache[3] || (_cache[3] = () => _ctx.store.goTo('start'))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.zero_layer_color'),
          onClick: _cache[0] || (_cache[0] = () => _ctx.store.goTo('bgColor'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              backgroundColor: _ctx.state.backgroundColor
            }, null, 8, ["backgroundColor"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.own_background'),
          onClick: _cache[1] || (_cache[1] = () => _ctx.store.goTo('ownBackgrounds'))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              checked: _ctx.state.selectedBackground && !_ctx.state.selectedBackground.has_room,
              backgroundImage: _ctx.state.selectedBackground && !_ctx.state.selectedBackground.has_room ? _ctx.state.selectedBackground.photo_box_url : ''
            }, {
              default: _withCtx(() => [
                (!_ctx.state.selectedBackground || _ctx.state.selectedBackground.has_room)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["checked", "backgroundImage"])
          ]),
          _: 1
        }, 8, ["text"]),
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.construct_background'),
          onClick: _cache[2] || (_cache[2] = () => _ctx.createConstructed())
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, {
              checked: _ctx.state.selectedBackground && _ctx.state.selectedBackground.has_room,
              backgroundImage: _ctx.state.selectedBackground && _ctx.state.selectedBackground.has_room ? _ctx.state.selectedBackground.photo_box_url : ''
            }, {
              default: _withCtx(() => [
                (!_ctx.state.selectedBackground || !_ctx.state.selectedBackground.has_room)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["checked", "backgroundImage"])
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    })
  ]))
}